<template>
    <modal
        v-if="show"
        :show="show"
        :type="type"
        :on-close="onClose"
        :render-custom-content="true"
        :render-close-btn="true"
        :options="[]"
    >
        <template #content>
            <div class="unit-cards-modal-content">
                <div class="unit-cards">
                    <slot />
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/Modal';

export default {
    name: 'UnitCardsModal',
    components: {
        Modal,
    },
    props: [
        'onClose',
        'show',
        'type',
    ],
};
</script>

<style scoped lang="scss">
@use "@/styles/styles.scss" as *;

.unit-cards-modal-content {
    max-width: none;
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 10px 4px 4px;
    -webkit-overflow-scrolling: touch;
}

.unit-cards {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 12px;
    min-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    width: max-content;

    &::-webkit-scrollbar {
        display: none;
    }

    :deep(.unit-card) {
        flex: 0 0 auto;
    }
}
</style>
